import $ from "jquery";
import Plyr from 'plyr';
import styles from 'plyr/dist/plyr.css';

    if (jQuery('.js-player').length > 0) {
        const players = Plyr.setup('.js-player', {
            autoplay: true,
            muted: true,
            youtube: {
                noCookie: true, // Use the privacy-enhanced mode (https://www.youtube-nocookie.com)
                controls: 0, // Hide native controls
                disablekb: 1, // Disable keyboard controls
                modestbranding: 1, // Hide YouTube logo
                rel: 0, // Do not show related videos
                showinfo: 0, // Hide video info
                iv_load_policy: 3, // Hide annotations
                cc_load_policy: 0 // Hide closed captions
            }
        });

        // Ensure YouTube and Vimeo videos are muted and autoplayed
        players.forEach(player => {
            player.on('ready', event => {
                const instance = event.detail.plyr;
                instance.muted = true;
                instance.play();
                instance.loop = { active: true }; // Enable looping
            });
        });
    }
